'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var ToggleableContext = require('./ToggleableContext.js');

var Toggleable = function (_a) {
    var _b = _a.allowMultiple, allowMultiple = _b === void 0 ? false : _b, children = _a.children, activeChildren = _a.activeChildren, setActiveChildren = _a.setActiveChildren;
    var isActive = react.useCallback(function (id) {
        if (activeChildren !== 0 && !activeChildren) {
            return false;
        }
        // We'll keep the array check here even though allowMultiple may be reliable enough
        return allowMultiple && Array.isArray(activeChildren)
            ? activeChildren.includes(id)
            : activeChildren === id;
    }, [activeChildren, allowMultiple]);
    var activate = react.useCallback(function (id) {
        var active = allowMultiple
            ? tslib.__spreadArray(tslib.__spreadArray([], (Array.isArray(activeChildren) ? activeChildren : []), true), [id], false) : id;
        setActiveChildren(active);
    }, [setActiveChildren, allowMultiple, activeChildren]);
    var deactivate = react.useCallback(function (id) {
        var active = 
        // We'll keep the array check here even though allowMultiple may be reliable enough
        allowMultiple && Array.isArray(activeChildren)
            ? activeChildren.filter(function (child) { return child !== id; })
            : undefined;
        setActiveChildren(active);
    }, [setActiveChildren, allowMultiple, activeChildren]);
    var toggleActive = react.useCallback(function (id) { return (isActive(id) ? deactivate(id) : activate(id)); }, [activate, deactivate, isActive]);
    return (jsxRuntime.jsx(ToggleableContext.default.Provider, tslib.__assign({ value: {
            activeChildren: activeChildren,
            isActive: isActive,
            toggleActive: toggleActive
        } }, { children: children })));
};
var Toggleable$1 = Toggleable;

exports.default = Toggleable$1;
//# sourceMappingURL=Toggleable.js.map
